/*
 * navInfo.tsx
 *
 * @Author: xiaoJQ
 * @Date: 2024-05-15 16:25:35
 *
 * Copyright © 2024 kingdee.com. All Rights Reserved.
 */
import React from 'react';
import CreateExtract from 'components/createExtract';
import HistoryList from 'components/historyList';
export var NavInfo = [
    {
        title: '新建提取',
        id: 'create_extract',
        render: React.createElement(CreateExtract, null),
    },
    {
        title: '历史记录',
        id: 'history_extract',
        render: React.createElement(HistoryList, null),
    },
];
